// extracted by mini-css-extract-plugin
export default {"backdrop":"LoadingBackdrop_backdrop__sGqjv","loader":"LoadingBackdrop_loader__IRp3E","spin":"LoadingBackdrop_spin__zJr3-","icon":"LoadingBackdrop_icon__UmoTj"};